import { useCallback, useEffect } from 'react';
import { observeResize } from '../utils/observe-resize.js';

function useCanvasRenderer(canvasRef, hue, colorSpace, renderFn) {
    const renderCanvas = useCallback(() => {
        const canvas = canvasRef.current;
        if (!canvas)
            return;
        const dpr = window.devicePixelRatio || 1;
        const rect = canvas.getBoundingClientRect();
        const width = Math.round(rect.width * dpr);
        const height = Math.round(rect.height * dpr);
        if (canvas.width !== width || canvas.height !== height) {
            canvas.width = width;
            canvas.height = height;
        }
        renderFn(canvas, hue, colorSpace);
    }, [canvasRef, hue, colorSpace, renderFn]);
    useEffect(renderCanvas, [renderCanvas]);
    // Re-render on resize (handles DPR changes and layout shifts)
    useEffect(() => observeResize(canvasRef, renderCanvas), [canvasRef, renderCanvas]);
}

export { useCanvasRenderer };
//# sourceMappingURL=color-area.hooks.js.map
